export default [
  {
    key: 'good',
    name: 'Good',
    value: 0,
    class: 'default',
  },
  {
    key: 'repair',
    name: 'Requires Bodywork repair',
    value: 1,
    class: 'info',
  },
  {
    key: 'maintenance',
    name: 'Requires Maintenance',
    value: 2,
    class: 'danger',
  },
];
